export default "__VITE_ASSET__DAqBx8Wk__"